<template>
  <div class="app-rate">
    <input-title :required="options.required" :description="options.description"/>
    <div class="input-groups review-grade">
      <div
        v-for="(_, i) in valueLocal"
        :key="'input-group-' + i"
        class="input-group"
        @click="removeError(i)">
        <el-switch
            v-model="valueLocal[i]"
            class="switch-type"
            active-color="#fff"
            inactive-color="#fff"
            active-text="Отрицательный"
            inactive-text="Положительный"
            :active-value="-1"
            :inactive-value="1"
            :key="'input-' + i"/>
        <div v-if="error[i]" class="ait_message ait_message--error">
          {{ error[i] }}</div>
      </div>
    </div>
    <add-rem-btns/>
  </div>
</template>

<script>
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
      errorBase: '',
    };
  },
};
</script>

<style lang="scss" scoped>
  .app-rate {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppRate.vue